import React, { useState, useEffect } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { CalendarIcon } from "lucide-react";
import { format } from "date-fns";

const CustomDatePicker = ({
  label,
  defaultValue,
  onDateChange,
  required = false,
  minDate=null, // <-- new prop
}) => {
  const [selectedDate, setSelectedDate] = useState(defaultValue);

  useEffect(() => {
    setSelectedDate(defaultValue);
  }, [defaultValue]);

  const handleDateSelect = (date) => {
    if (date) {
      // Set time to noon local time to avoid timezone issues
      const localDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0);
      setSelectedDate(localDate);
      onDateChange(localDate);
    } else {
      setSelectedDate(date);
      onDateChange(date);
    }
  };

  return (
    <div className="space-y-2 w-full">
      <label className="block text-sm font-medium text-gray-700">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <Popover>
        <PopoverTrigger asChild>
          <Button variant="outline" className="w-full justify-start text-left font-normal">
            <CalendarIcon className="mr-2 h-4 w-4" />
            {selectedDate ? format(selectedDate, "PPP") : <span>Select a date</span>}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0">
          <Calendar
            mode="single"
            selected={selectedDate}
            onSelect={handleDateSelect}
            initialFocus
            disabled={(date) => {
              if(minDate){
                return date < minDate
              }
              return date < new Date()
            }
          }
          />
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default CustomDatePicker;
